import { Route, Routes } from 'react-router-dom';
import AuthBaseScreen from './screens/AuthBaseScreen';

Auth.propTypes = {};

function Auth(props) {
  return (
    <Routes>
      <Route path="*" element={<AuthBaseScreen />} />
    </Routes>
  );
}

export default Auth;
